export default __webpack_public_path__ + "static/international-yards-mobile-06d0beb29b485100806200e1c2486bfe.svg";